<template>
    <div class="form_group form_group_document_brand image_editor_wrapper">
        <display-message :option="message_option"></display-message>

        <div class="image_editor_container">
            <div class="image_editor_canvas_container">
                <div class="image_editor_source_wrapper">
                    <div class="image_editor_source_container">
<!--                        <canvas class="image_editor_source" style="cursor: pointer;" v-draw-canvas="dom.source_image" @load="canvas_loaded($event,'source_image')"></canvas>-->
                        <canvas class="image_editor_source_canvas" style="cursor: pointer;border-radius: 5px;border: 2px solid black;" @click="canvas_clicked($event)" @mousedown="source_canvas_mousedown" @mousemove="source_canvas_mousemove" @mouseup="source_canvas_mouseup" width="500" height="500"></canvas>
                        <img style="display: none;" class="image_editor_source_image" :src="src.source_image" @load="image_loaded($event,'source_image')">
                    </div>
                </div>
                <div class="image_editor_target_wrapper" style="display: none;">
                    <div class="image_editor_target_container">
                        <canvas class="image_editor_target_canvas" width="100" height="100"></canvas>
                        <img class="image_editor_target_image">
                    </div>
                </div>
                <div class="clear"></div>
            </div>
            <div class="image_editor_file_input_container" style="padding:1em 0.5em;">
                <input class="image_editor_file_input" type="file" accept="image/*" @change="change_file_input">
            </div>
        </div>

        <div class="form_row form_row_controller_container">
            <input type="button" class="btn btn-primary" value="Save" @click="save()">
            <input type="button" class="btn btn-secondary-inverse" value="Cancel" @click="cancel()">
        </div>
<!--        <div class="form_row form_row_controller_container">-->
<!--            <input type="button" class="btn btn-primary" value="Save" @click="save()">-->
<!--            <input type="button" class="btn btn-secondary-inverse" value="Cancel" @click="cancel()">-->
<!--        </div>-->
    </div>    
</template>

<script>
    export default {
        name: "UpdateImage",
        props: ['option','current_id'],
        data() {
            let current_object = this;
            let data_set = {
                module_name: 'image',
                src: {
                    source_image: null,
                    target_image: null,
                },
                // canvas: {
                //     source_image: null,
                //     target_image: null,
                // },
                // ratio: {
                //     source_image: null,
                //     target_image: null,
                // },
                jquery_element: {
                    source_wrapper: null,
                    source_canvas: null,
                    target_canvas: null,
                    source_image: null,
                    target_image: null,
                    file_input: null
                },
                dom_element: {},
                image_quality: {
                    source_image: 0.75,
                    target_image: 0.75,
                },
                canvas_background: {
                    source_canvas: null,
                    target_canvas: null,
                },
                canvas_context: {
                    source_canvas: null,
                    target_canvas: null,
                },
                draw_region: {
                    source_canvas: [0,0,0,0],
                    target_canvas: [0,0,0,0],
                },
                source_image_max_width: 2500,
                source_image_max_height: 2500,
                target_image: {
                    width:'auto',
                    height:'auto',
                    ratio:'auto'
                },

                target_image_format: 'image/jpeg',

                image_area: {
                    'start': [0,0],
                    'size': [1,1],
                },

                select_area: {
                    'start': [0,0],
                    'size': [1,1],
                },

                select_area_start: {
                    'start': [0,0],
                    'size': [1,1],
                },

                select_area_ratio: [0.33,3],
                dot_radius: 6,

                source_canvas_margin: 0.2,

                action_id: 0,
                // Mouse coordinates
                page_coords_start: [0,0],
                page_coords: [0,0],
                page_coords_offsets: [0,0],
                message_option:{}

            };
            // let current_object = this;
            // data_set.cache_data = current_object.reset_cache_data({init:true,module_name:data_set.module_name});
            // Object.keys(data_set.cache_data).forEach(function (field_name) {
            //     data_set.current_chosen[field_name] = '';
            // });
            Object.keys(current_object.option).forEach(function (option_key) {
                data_set[option_key] = current_object.option[option_key];
            });

            if (!data_set.canvas_transparent_image) {
                data_set.canvas_transparent_image = document.createElement('img');
                data_set.canvas_transparent_image.src = '/assets/image/bg_canvas_transparent.jpg';
            }

            // current_object.get_available_fields(data_set);
            return data_set;
        },
        directives: {
            // drawCanvas: function (canvas_dom, dom) {
            //     console.log('allen debug drawCanvas',canvas_dom,dom);
            //     // dom.value.source_canvas = canvas_dom;
            //     // console.log(source_image_pass_down.value.width,source_image_pass_down.value.height);
            //     // if (source_image_pass_down.value) {
            //     //     let temp_img = document.createElement('img');
            //     //     temp_img.src = source_image_pass_down.value;
            //     //     console.log(temp_img,temp_img.width,temp_img.height);
            //     // }
            // }

        },
        mounted() {
            let current_object = this;
            let root = current_object.$root;
            if (root.item_field && root.item_field[current_object.module_name]) {
                current_object.current_item_field = current_object.$root.item_field[current_object.module_name];
                current_object.get_available_fields();
            }

            // current_object.dom_element.source_image = $(current_object.$vnode.elm).find('.image_editor_source_image')[0];
            // current_object.dom_element.target_image = $(current_object.$vnode.elm).find('.image_editor_target_image')[0];
            // current_object.dom_element.source_canvas = $(current_object.$el).find('.image_editor_source')[0];
            // current_object.dom_element.target_canvas = $(current_object.$el).find('.image_editor_target')[0];
            Object.keys(current_object.jquery_element).forEach(function (dom_key) {
                current_object.jquery_element[dom_key] = $(current_object.$el).find('.image_editor_'+dom_key);
                current_object.dom_element[dom_key] = current_object.jquery_element[dom_key][0];
            });
            current_object.draw_region['source_canvas'][2] = current_object.jquery_element.source_canvas.width();
            current_object.draw_region['source_canvas'][3] = current_object.jquery_element.source_canvas.height();
            Object.keys(current_object.canvas_context).forEach(function (dom_key) {
                current_object.canvas_context[dom_key] = current_object.dom_element[dom_key].getContext('2d');
            });

            console.log('current_object',current_object,current_object.$vnode);
            console.log($(current_object.$vnode.elm).find('.image_editor_source_image'));


            let select_area = current_object.select_area;
            let select_area_ratio = current_object.select_area_ratio;
            let select_area_start = current_object.select_area_start;
            let source_canvas_draw_region = current_object.draw_region.source_canvas;
            let target_canvas_draw_region = current_object.draw_region.target_canvas;
            let source_wrapper = current_object.jquery_element.source_wrapper;
            let source_canvas = current_object.jquery_element.source_canvas;
            let target_canvas = current_object.jquery_element.target_canvas;
            let source_image = current_object.dom_element.source_image;
            let source_ctx = current_object.canvas_context.source_canvas;
            let target_ctx = current_object.canvas_context.target_canvas;
            let source_canvas_background = current_object.canvas_background.source_canvas;

            let page_coords_start = current_object.page_coords_start;
            let page_coords = current_object.page_coords;
            let page_coords_offsets = current_object.page_coords_offsets;
            let dot_radius = current_object.dot_radius;


        },
        methods: {
            // Mouse Down
            source_canvas_mousedown: function(event) {
                let current_object = this;
                let select_area = current_object.select_area;
                let select_area_ratio = current_object.select_area_ratio;
                let select_area_start = current_object.select_area_start;
                let source_wrapper = current_object.jquery_element.source_wrapper;
                let source_canvas = current_object.jquery_element.source_canvas;
                let source_ctx = current_object.canvas_context.source_canvas;

                let page_coords_offsets = current_object.page_coords_offsets;
                let page_coords_start = current_object.page_coords_start;
                let page_coords = current_object.page_coords;
                let dot_radius = current_object.dot_radius;

                // Mouse Left Button Down
                if (event.which == 1)
                {
                    event.preventDefault();
                    page_coords = [event.pageX - source_wrapper.offset().left, event.pageY - source_wrapper.offset().top];

                    current_object.action_id = 0;

                    // Set Action Move if Click inside select area
                    source_ctx.beginPath();
                    source_ctx.rect(select_area['start'][0]*source_canvas.width(),select_area['start'][1]*source_canvas.height(),select_area['size'][0]*source_canvas.width(),select_area['size'][1]*source_canvas.height());
                    source_ctx.closePath();

                    if (source_ctx.isPointInPath(page_coords[0],page_coords[1]))
                    {
                        current_object.action_id = 1;
                    }

                    // When ratio is fixed, there's no edge resize function
                    if (select_area_ratio[0]<select_area_ratio[1])
                    {
                        // Set Action Resize if click inside Edge Region
                        source_ctx.beginPath();
                        source_ctx.rect(select_area['start'][0]*source_canvas.width(),select_area['start'][1]*source_canvas.height()-dot_radius,select_area['size'][0]*source_canvas.width(),dot_radius*2);
                        source_ctx.closePath();
                        if (source_ctx.isPointInPath(page_coords[0],page_coords[1]))
                        {
                            current_object.action_id = 3;
                        }

                        source_ctx.beginPath();
                        source_ctx.rect((select_area['start'][0]+select_area['size'][0])*source_canvas.width()-dot_radius,select_area['start'][1]*source_canvas.height(),dot_radius*2,select_area['size'][1]*source_canvas.height());
                        source_ctx.closePath();
                        if (source_ctx.isPointInPath(page_coords[0],page_coords[1]))
                        {
                            current_object.action_id = 5;
                        }

                        source_ctx.beginPath();
                        source_ctx.rect(select_area['start'][0]*source_canvas.width(),(select_area['start'][1]+select_area['size'][1])*source_canvas.height()-dot_radius,select_area['size'][0]*source_canvas.width(),dot_radius*2);
                        source_ctx.closePath();
                        if (source_ctx.isPointInPath(page_coords[0],page_coords[1]))
                        {
                            current_object.action_id = 7;
                        }

                        source_ctx.beginPath();
                        source_ctx.rect(select_area['start'][0]*source_canvas.width()-dot_radius,select_area['start'][1]*source_canvas.height(),dot_radius*2,select_area['size'][1]*source_canvas.height());
                        source_ctx.closePath();
                        if (source_ctx.isPointInPath(page_coords[0],page_coords[1]))
                        {
                            current_object.action_id = 9;
                        }
                    }

                    // Set Action Resize if click inside Corner Region
                    source_ctx.beginPath();
                    source_ctx.arc(select_area['start'][0]*source_canvas.width(),select_area['start'][1]*source_canvas.height(),dot_radius,0,2*Math.PI);
                    source_ctx.closePath();
                    if (source_ctx.isPointInPath(page_coords[0],page_coords[1]))
                    {
                        current_object.action_id = 2;
                    }

                    source_ctx.beginPath();
                    source_ctx.arc((select_area['start'][0]+select_area['size'][0])*source_canvas.width(),select_area['start'][1]*source_canvas.height(),dot_radius,0,2*Math.PI);
                    source_ctx.closePath();
                    if (source_ctx.isPointInPath(page_coords[0],page_coords[1]))
                    {
                        current_object.action_id = 4;
                    }

                    source_ctx.beginPath();
                    source_ctx.arc((select_area['start'][0]+select_area['size'][0])*source_canvas.width(),(select_area['start'][1]+select_area['size'][1])*source_canvas.height(),dot_radius,0,2*Math.PI);
                    source_ctx.closePath();
                    if (source_ctx.isPointInPath(page_coords[0],page_coords[1]))
                    {
                        current_object.action_id = 6;
                    }

                    source_ctx.beginPath();
                    source_ctx.arc(select_area['start'][0]*source_canvas.width(),(select_area['start'][1]+select_area['size'][1])*source_canvas.height(),dot_radius,0,2*Math.PI);
                    source_ctx.closePath();
                    if (source_ctx.isPointInPath(page_coords[0],page_coords[1]))
                    {
                        current_object.action_id = 8;
                    }

                    // Set Action Start Point
                    if (current_object.action_id > 0)
                    {
                        page_coords_start[0] = page_coords[0];
                        page_coords_start[1] = page_coords[1];
                        select_area_start['start'][0] = select_area['start'][0];
                        select_area_start['start'][1] = select_area['start'][1];
                        select_area_start['size'][0] = select_area['size'][0];
                        select_area_start['size'][1] = select_area['size'][1];
                    }

                    current_object.change_cursor(event,current_object.action_id);
                }
            },

            // Mouse Move
            source_canvas_mousemove: function(event) {
                let current_object = this;
                let select_area = current_object.select_area;
                let select_area_ratio = current_object.select_area_ratio;
                let select_area_start = current_object.select_area_start;
                let source_canvas_draw_region = current_object.draw_region.source_canvas;
                let source_wrapper = current_object.jquery_element.source_wrapper;
                let source_canvas = current_object.jquery_element.source_canvas;
                let target_canvas = current_object.jquery_element.target_canvas;
                let source_ctx = current_object.canvas_context.source_canvas;
                let source_canvas_background = current_object.canvas_background.source_canvas;

                let page_coords_offsets = current_object.page_coords_offsets;
                let page_coords_start = current_object.page_coords_start;
                let page_coords = current_object.page_coords;
                let dot_radius = current_object.dot_radius;

                if (source_canvas_background)
                {
                    event.preventDefault();
                    page_coords = [event.pageX - source_wrapper.offset().left, event.pageY - source_wrapper.offset().top];

                    switch (event.which)
                    {
                        // No Mouse Button Down
                        case 0:
                            var temp_action_id = 0;
                            source_ctx.beginPath();
                            source_ctx.rect(select_area['start'][0]*source_canvas.width(),select_area['start'][1]*source_canvas.height(),select_area['size'][0]*source_canvas.width(),select_area['size'][1]*source_canvas.height());
                            source_ctx.closePath();
                            if (source_ctx.isPointInPath(page_coords[0],page_coords[1]))
                            {
                                temp_action_id = 1;
                            }

                            // When ratio is fixed, there's no edge resize function
                            if (select_area_ratio[0]<select_area_ratio[1])
                            {
                                // Set Action Resize if click inside Edge Region
                                source_ctx.beginPath();
                                source_ctx.rect(select_area['start'][0]*source_canvas.width(),select_area['start'][1]*source_canvas.height()-dot_radius,select_area['size'][0]*source_canvas.width(),dot_radius*2);
                                source_ctx.closePath();
                                if (source_ctx.isPointInPath(page_coords[0],page_coords[1]))
                                {
                                    temp_action_id = 3;
                                }

                                source_ctx.beginPath();
                                source_ctx.rect((select_area['start'][0]+select_area['size'][0])*source_canvas.width()-dot_radius,select_area['start'][1]*source_canvas.height(),dot_radius*2,select_area['size'][1]*source_canvas.height());
                                source_ctx.closePath();
                                if (source_ctx.isPointInPath(page_coords[0],page_coords[1]))
                                {
                                    temp_action_id = 5;
                                }

                                source_ctx.beginPath();
                                source_ctx.rect(select_area['start'][0]*source_canvas.width(),(select_area['start'][1]+select_area['size'][1])*source_canvas.height()-dot_radius,select_area['size'][0]*source_canvas.width(),dot_radius*2);
                                source_ctx.closePath();
                                if (source_ctx.isPointInPath(page_coords[0],page_coords[1]))
                                {
                                    temp_action_id = 7;
                                }

                                source_ctx.beginPath();
                                source_ctx.rect(select_area['start'][0]*source_canvas.width()-dot_radius,select_area['start'][1]*source_canvas.height(),dot_radius*2,select_area['size'][1]*source_canvas.height());
                                source_ctx.closePath();
                                if (source_ctx.isPointInPath(page_coords[0],page_coords[1]))
                                {
                                    temp_action_id = 9;
                                }
                            }

                            source_ctx.beginPath();
                            source_ctx.arc(select_area['start'][0]*source_canvas.width(),select_area['start'][1]*source_canvas.height(),dot_radius,0,2*Math.PI);
                            source_ctx.closePath();
                            if (source_ctx.isPointInPath(page_coords[0],page_coords[1]))
                            {
                                temp_action_id = 2;
                            }

                            source_ctx.beginPath();
                            source_ctx.arc((select_area['start'][0]+select_area['size'][0])*source_canvas.width(),select_area['start'][1]*source_canvas.height(),dot_radius,0,2*Math.PI);
                            source_ctx.closePath();
                            if (source_ctx.isPointInPath(page_coords[0],page_coords[1]))
                            {
                                temp_action_id = 4;
                            }

                            source_ctx.beginPath();
                            source_ctx.arc((select_area['start'][0]+select_area['size'][0])*source_canvas.width(),(select_area['start'][1]+select_area['size'][1])*source_canvas.height(),dot_radius,0,2*Math.PI);
                            source_ctx.closePath();
                            if (source_ctx.isPointInPath(page_coords[0],page_coords[1]))
                            {
                                temp_action_id = 6;
                            }

                            source_ctx.beginPath();
                            source_ctx.arc(select_area['start'][0]*source_canvas.width(),(select_area['start'][1]+select_area['size'][1])*source_canvas.height(),dot_radius,0,2*Math.PI);
                            source_ctx.closePath();
                            if (source_ctx.isPointInPath(page_coords[0],page_coords[1]))
                            {
                                temp_action_id = 8;
                            }

                            current_object.change_cursor(event,temp_action_id);
                            break;


                        // Mouse Left Button Down
                        case 1:
                            page_coords_offsets = [page_coords[0] - page_coords_start[0],page_coords[1] - page_coords_start[1]];
                            // console.log('allen debug mousemove left button down',page_coords,page_coords_start,page_coords_offsets);
                            switch(current_object.action_id)
                            {
                                case 1:
                                    select_area['start'][0] = select_area_start['start'][0]+page_coords_offsets[0]/source_canvas.width();
                                    select_area['start'][1] = select_area_start['start'][1]+page_coords_offsets[1]/source_canvas.height();
                                    select_area['size'][0] = select_area_start['size'][0];
                                    select_area['size'][1] = select_area_start['size'][1];
                                    if (select_area['start'][0] < source_canvas_draw_region[0]/source_canvas.width())
                                    {
                                        select_area['start'][0] =  source_canvas_draw_region[0]/source_canvas.width();
                                    }
                                    if (select_area['start'][1] <  source_canvas_draw_region[1]/source_canvas.height())
                                    {
                                        select_area['start'][1] = source_canvas_draw_region[1]/source_canvas.height();
                                    }
                                    if (select_area['start'][0]+select_area['size'][0] > (source_canvas_draw_region[0]+source_canvas_draw_region[2])/source_canvas.width())
                                    {
                                        select_area['start'][0] = (source_canvas_draw_region[0]+source_canvas_draw_region[2])/source_canvas.width() - select_area['size'][0];
                                    }
                                    if (select_area['start'][1]+select_area['size'][1] > (source_canvas_draw_region[1]+source_canvas_draw_region[3])/source_canvas.height())
                                    {
                                        select_area['start'][1] = (source_canvas_draw_region[1]+source_canvas_draw_region[3])/source_canvas.height() - select_area['size'][1];
                                    }
                                    break;
                                case 2:
                                    select_area['start'][0] = select_area_start['start'][0]+page_coords_offsets[0]/source_canvas.width();
                                    select_area['start'][1] = select_area_start['start'][1]+page_coords_offsets[1]/source_canvas.height();
                                    select_area['size'][0] = select_area_start['size'][0]-page_coords_offsets[0]/source_canvas.width();
                                    select_area['size'][1] = select_area_start['size'][1]-page_coords_offsets[1]/source_canvas.height();
                                    if (select_area['start'][0] < source_canvas_draw_region[0]/source_canvas.width())
                                    {
                                        select_area['size'][0] = select_area_start['start'][0] + select_area_start['size'][0] - source_canvas_draw_region[0]/source_canvas.width();
                                        select_area['start'][0] =  source_canvas_draw_region[0]/source_canvas.width();
                                    }
                                    if (select_area['start'][1] <  source_canvas_draw_region[1]/source_canvas.height())
                                    {
                                        select_area['size'][1] = select_area_start['start'][1] + select_area_start['size'][1] - source_canvas_draw_region[1]/source_canvas.height();
                                        select_area['start'][1] = source_canvas_draw_region[1]/source_canvas.height();
                                    }
                                    if (select_area['size'][0] < 0.2)
                                    {
                                        select_area['size'][0] = 0.2;
                                        select_area['start'][0] = select_area_start['start'][0]+select_area_start['size'][0]-select_area['size'][0];
                                    }
                                    if (select_area['size'][1] < 0.2)
                                    {
                                        select_area['size'][1] = 0.2;
                                        select_area['start'][1] = select_area_start['start'][1]+select_area_start['size'][1]-select_area['size'][1];
                                    }
                                    if (select_area['size'][0]/select_area['size'][1] < select_area_ratio[0])
                                    {
                                        select_area['size'][1] = select_area['size'][0] / select_area_ratio[0];
                                        select_area['start'][1] = select_area_start['start'][1] + select_area_start['size'][1] - select_area['size'][1];
                                    }
                                    if (select_area['size'][0]/select_area['size'][1] > select_area_ratio[1])
                                    {
                                        select_area['start'][0] = select_area['start'][0] + select_area['size'][0] - select_area['size'][1] * select_area_ratio[1];
                                        select_area['size'][0] = select_area['size'][1] * select_area_ratio[1];

                                    }
                                    break;
                                case 3:
                                    select_area['start'][0] = select_area_start['start'][0];
                                    select_area['start'][1] = select_area_start['start'][1]+page_coords_offsets[1]/source_canvas.height();
                                    select_area['size'][0] = select_area_start['size'][0];
                                    select_area['size'][1] = select_area_start['size'][1]-page_coords_offsets[1]/source_canvas.height();
                                    if (select_area['start'][1] <  source_canvas_draw_region[1]/source_canvas.height())
                                    {
                                        select_area['size'][1] = select_area_start['start'][1] + select_area_start['size'][1] - source_canvas_draw_region[1]/source_canvas.height();
                                        select_area['start'][1] = source_canvas_draw_region[1]/source_canvas.height();
                                    }
                                    if (select_area['size'][1] < 0.2)
                                    {
                                        select_area['size'][1] = 0.2;
                                        select_area['start'][1] = select_area_start['start'][1]+select_area_start['size'][1]-select_area['size'][1];
                                    }
                                    if (select_area['size'][0]/select_area['size'][1] < select_area_ratio[0])
                                    {
                                        select_area['start'][1] = select_area['start'][1] + select_area['size'][1] - select_area['size'][0] / select_area_ratio[0];
                                        select_area['size'][1] = select_area['size'][0] / select_area_ratio[0];
                                    }
                                    if (select_area['size'][0]/select_area['size'][1] > select_area_ratio[1])
                                    {
                                        select_area['start'][1] = select_area['start'][1] + select_area['size'][1] - select_area['size'][0] / select_area_ratio[1];
                                        select_area['size'][1] = select_area['size'][0] / select_area_ratio[1];
                                    }
                                    break;
                                case 4:
                                    select_area['start'][0] = select_area_start['start'][0];
                                    select_area['start'][1] = select_area_start['start'][1]+page_coords_offsets[1]/source_canvas.height();
                                    select_area['size'][0] = select_area_start['size'][0]+page_coords_offsets[0]/source_canvas.width();
                                    select_area['size'][1] = select_area_start['size'][1]-page_coords_offsets[1]/source_canvas.height();
                                    if ((select_area['start'][0] + select_area['size'][0]) > (source_canvas_draw_region[0]+source_canvas_draw_region[2])/source_canvas.width())
                                    {
                                        select_area['size'][0] =  (source_canvas_draw_region[0]+source_canvas_draw_region[2])/source_canvas.width() - select_area['start'][0];
                                    }
                                    if (select_area['start'][1] <  source_canvas_draw_region[1]/source_canvas.height())
                                    {
                                        select_area['size'][1] = select_area_start['start'][1] + select_area_start['size'][1] - source_canvas_draw_region[1]/source_canvas.height();
                                        select_area['start'][1] = source_canvas_draw_region[1]/source_canvas.height();
                                    }
                                    if (select_area['size'][0] < 0.2)
                                    {
                                        select_area['size'][0] = 0.2;
                                        select_area['start'][0] = select_area_start['start'][0];
                                    }
                                    if (select_area['size'][1] < 0.2)
                                    {
                                        select_area['size'][1] = 0.2;
                                        select_area['start'][1] = select_area_start['start'][1]+select_area_start['size'][1]-select_area['size'][1];
                                    }
                                    if (select_area['size'][0]/select_area['size'][1] < select_area_ratio[0])
                                    {
                                        select_area['size'][1] = select_area['size'][0] / select_area_ratio[0];
                                        select_area['start'][1] = select_area_start['start'][1] + select_area_start['size'][1] - select_area['size'][1];
                                    }
                                    if (select_area['size'][0]/select_area['size'][1] > select_area_ratio[1])
                                    {
                                        select_area['size'][0] = select_area['size'][1] * select_area_ratio[1];

                                    }
                                    break;
                                case 5:
                                    select_area['start'][0] = select_area_start['start'][0];
                                    select_area['start'][1] = select_area_start['start'][1];
                                    select_area['size'][0] = select_area_start['size'][0]+page_coords_offsets[0]/source_canvas.width();
                                    select_area['size'][1] = select_area_start['size'][1];
                                    if ((select_area['start'][0] + select_area['size'][0]) > (source_canvas_draw_region[0]+source_canvas_draw_region[2])/source_canvas.width())
                                    {
                                        select_area['size'][0] =  (source_canvas_draw_region[0]+source_canvas_draw_region[2])/source_canvas.width() - select_area['start'][0];
                                    }
                                    if (select_area['size'][0] < 0.2)
                                    {
                                        select_area['size'][0] = 0.2;
                                    }
                                    if (select_area['size'][0]/select_area['size'][1] < select_area_ratio[0])
                                    {
                                        select_area['size'][0] = select_area['size'][1] * select_area_ratio[0];

                                    }
                                    if (select_area['size'][0]/select_area['size'][1] > select_area_ratio[1])
                                    {
                                        select_area['size'][0] = select_area['size'][1] * select_area_ratio[1];
                                    }
                                    break;
                                case 6:
                                    select_area['start'][0] = select_area_start['start'][0];
                                    select_area['start'][1] = select_area_start['start'][1];
                                    select_area['size'][0] = select_area_start['size'][0]+page_coords_offsets[0]/source_canvas.width();
                                    select_area['size'][1] = select_area_start['size'][1]+page_coords_offsets[1]/source_canvas.height();

                                    if (select_area['start'][0]+select_area['size'][0] > (source_canvas_draw_region[0]+source_canvas_draw_region[2])/source_canvas.width())
                                    {
                                        select_area['size'][0] = (source_canvas_draw_region[0]+source_canvas_draw_region[2])/source_canvas.width() - select_area['start'][0];
                                    }
                                    if (select_area['start'][1]+select_area['size'][1] > (source_canvas_draw_region[1]+source_canvas_draw_region[3])/source_canvas.height())
                                    {
                                        select_area['size'][1] = (source_canvas_draw_region[1]+source_canvas_draw_region[3])/source_canvas.height() - select_area['start'][1];
                                    }
                                    if (select_area['size'][0] < 0.2)
                                    {
                                        select_area['size'][0] = 0.2;
                                    }
                                    if (select_area['size'][1] < 0.2)
                                    {
                                        select_area['size'][1] = 0.2;
                                    }
                                    if (select_area['size'][0]/select_area['size'][1] < select_area_ratio[0])
                                    {
                                        select_area['size'][1] = select_area['size'][0] / select_area_ratio[0];

                                    }
                                    if (select_area['size'][0]/select_area['size'][1] > select_area_ratio[1])
                                    {
                                        select_area['size'][0] = select_area['size'][1] * select_area_ratio[1];
                                    }
                                    break;
                                case 7:
                                    select_area['start'][0] = select_area_start['start'][0];
                                    select_area['start'][1] = select_area_start['start'][1];
                                    select_area['size'][0] = select_area_start['size'][0];
                                    select_area['size'][1] = select_area_start['size'][1]+page_coords_offsets[1]/source_canvas.height();

                                    if (select_area['start'][1]+select_area['size'][1] > (source_canvas_draw_region[1]+source_canvas_draw_region[3])/source_canvas.height())
                                    {
                                        select_area['size'][1] = (source_canvas_draw_region[1]+source_canvas_draw_region[3])/source_canvas.height() - select_area['start'][1];
                                    }
                                    if (select_area['size'][1] < 0.2)
                                    {
                                        select_area['size'][1] = 0.2;
                                    }
                                    if (select_area['size'][0]/select_area['size'][1] < select_area_ratio[0])
                                    {
                                        select_area['size'][1] = select_area['size'][0] / select_area_ratio[0];

                                    }
                                    if (select_area['size'][0]/select_area['size'][1] > select_area_ratio[1])
                                    {
                                        select_area['size'][1] = select_area['size'][0] / select_area_ratio[1];
                                    }
                                    break;
                                case 8:
                                    select_area['start'][0] = select_area_start['start'][0]+page_coords_offsets[0]/source_canvas.width();
                                    select_area['start'][1] = select_area_start['start'][1];
                                    select_area['size'][0] = select_area_start['size'][0]-page_coords_offsets[0]/source_canvas.width();
                                    select_area['size'][1] = select_area_start['size'][1]+page_coords_offsets[1]/source_canvas.height();

                                    if (select_area['start'][0] < source_canvas_draw_region[0]/source_canvas.width())
                                    {
                                        select_area['size'][0] +=  select_area['start'][0] - source_canvas_draw_region[0]/source_canvas.width();
                                        select_area['start'][0] =  source_canvas_draw_region[0]/source_canvas.width();
                                    }
                                    if (select_area['start'][1]+select_area['size'][1] > (source_canvas_draw_region[1]+source_canvas_draw_region[3])/source_canvas.height())
                                    {
                                        select_area['size'][1] = (source_canvas_draw_region[1]+source_canvas_draw_region[3])/source_canvas.height() - select_area['start'][1];
                                    }
                                    if (select_area['size'][0] < 0.2)
                                    {
                                        select_area['size'][0] = 0.2;
                                        select_area['start'][0] = select_area_start['start'][0]+select_area_start['size'][0]-select_area['size'][0];
                                    }
                                    if (select_area['size'][1] < 0.2)
                                    {
                                        select_area['size'][1] = 0.2;
                                    }
                                    if (select_area['size'][0]/select_area['size'][1] < select_area_ratio[0])
                                    {
                                        select_area['size'][1] = select_area['size'][0] / select_area_ratio[0];
                                    }
                                    if (select_area['size'][0]/select_area['size'][1] > select_area_ratio[1])
                                    {
                                        select_area['size'][0] = select_area['size'][1] * select_area_ratio[1];
                                        select_area['start'][0] = select_area_start['start'][0] + select_area_start['size'][0] - select_area['size'][0];
                                    }
                                    break;
                                case 9:
                                    select_area['start'][0] = select_area_start['start'][0]+page_coords_offsets[0]/source_canvas.width();
                                    select_area['start'][1] = select_area_start['start'][1];
                                    select_area['size'][0] = select_area_start['size'][0]-page_coords_offsets[0]/source_canvas.width();
                                    select_area['size'][1] = select_area_start['size'][1];

                                    if (select_area['start'][0] < source_canvas_draw_region[0]/source_canvas.width())
                                    {
                                        select_area['size'][0] +=  select_area['start'][0] - source_canvas_draw_region[0]/source_canvas.width();
                                        select_area['start'][0] =  source_canvas_draw_region[0]/source_canvas.width();
                                    }
                                    if (select_area['size'][0] < 0.2)
                                    {
                                        select_area['size'][0] = 0.2;
                                        select_area['start'][0] = select_area_start['start'][0]+select_area_start['size'][0]-select_area['size'][0];
                                    }
                                    if (select_area['size'][0]/select_area['size'][1] < select_area_ratio[0])
                                    {
                                        select_area['start'][0] = select_area['start'][0] + select_area['size'][0] - select_area['size'][1] * select_area_ratio[0];
                                        select_area['size'][0] = select_area['size'][1] * select_area_ratio[0];
                                    }
                                    if (select_area['size'][0]/select_area['size'][1] > select_area_ratio[1])
                                    {
                                        select_area['start'][0] = select_area['start'][0] + select_area['size'][0] - select_area['size'][1] * select_area_ratio[1];
                                        select_area['size'][0] = select_area['size'][1] * select_area_ratio[1];
                                    }
                                    break;
                                default:
                            }
                            if (source_canvas_background)
                            {
                                current_object.draw_canvas('source_canvas');
                                current_object.draw_canvas('target_canvas');
                            }
                            break;
                        default:
                    }
                }
                else
                {
                    current_object.change_cursor(event,10);
                }
            },

            // Mouse Up
            source_canvas_mouseup: function(event) {
                let current_object = this;
                let source_canvas = current_object.jquery_element.source_canvas;
                let source_canvas_background = current_object.canvas_background.source_canvas;

                event.preventDefault();
                current_object.action_id = 0;
                current_object.change_cursor(event,0);
                if (source_canvas_background)
                {
                    current_object.draw_canvas('source_canvas');
                }
            },

            // image_loaded: function (image_name) {
            //     let current_object = this;
            //     console.log('image_loaded',current_object.dom_element[image_name].width,current_object.dom_element[image_name].height);
            // },
            source_image_initialize: function(){
                let current_object = this;
                let source_image = current_object.dom_element.source_image;
                let new_image_width = source_image.width;
                let new_image_height = source_image.height;
                if (new_image_width > current_object.source_image_max_width)
                {
                    new_image_height = new_image_height / new_image_width * current_object.source_image_max_width;
                    new_image_width = current_object.source_image_max_width;
                }
                if (new_image_height > current_object.source_image_max_height)
                {
                    new_image_width = new_image_width / new_image_height * current_object.source_image_max_height;
                    new_image_height = current_object.source_image_max_height;
                }

                if (new_image_width != source_image.width)
                {
                    let temp_canvas = document.createElement('canvas');
                    temp_canvas.width = new_image_width;
                    temp_canvas.height = new_image_height;
                    let temp_ctx = temp_canvas.getContext('2d');

                    if (current_object.target_image_format === 'image/png') {
                        temp_ctx.clearRect(0,0,new_image_width,new_image_height);
                        temp_ctx.drawImage(current_object.canvas_transparent_image,0,0,new_image_width,new_image_height);
                    } else {
                        temp_ctx.fillStyle = '#ffffff';
                        temp_ctx.fillRect(0,0,new_image_width,new_image_height);
                    }
                    temp_ctx.drawImage(source_image,0,0,new_image_width,new_image_height);
                    current_object.src.source_image = temp_canvas.toDataURL(current_object.target_image_format,current_object.image_quality.source_image);
                }
                current_object.src.target_image = '';
                // $(window).trigger('resize');
            },
            canvas_clicked: function (event) {
                let current_object = this;
                if (current_object.canvas_background['source_canvas'] == null)
                {
                    event.preventDefault();
                    current_object.jquery_element.file_input.click();
                }
            },
            image_loaded: function (event, image_type) {
                console.log('image_loaded',event, image_type);
                let image = event.target;
                let current_object = this;
                console.log(typeof image);
                console.log($(image).width());
                // current_object.dom_element[image_type] = image;
                if (image_type === 'source_image') {
                    current_object.source_image_initialize();
                    current_object.set_background('source_canvas');
                    current_object.draw_canvas('source_canvas');
                    current_object.draw_canvas('target_canvas');
                }
            },
            read_file: function (file) {
                var error_message= '';
                let current_object = this;

                // Check that there is a file uploaded
                if(file)
                {
                    // Check file type
                    if(file.type != 'image/jpeg' && file.type != 'image/png' && file.type != 'image/gif')
                    {
                        error_message = 'Please upload a .jpg, .png or .gif file';
                    }
                    else
                    {
                        // Check file size
                        if(file.size > 10485760)
                        {
                            error_message = 'Please upload an image smaller than 10MB';
                        }
                        else
                        {
                            var reader = new FileReader();

                            // When it's loaded, we'll assign the read section to a variable (bg_img);
                            reader.onload = function(event){
                                current_object.src.source_image = event.target.result;
                            }

                            // Pass the reader the file to read and give us the DataURL
                            console.log('allen debug read_file',file);
                            reader.readAsDataURL(file);
                        }
                    }
                }
                else
                {
                    error_message = 'Unable to read source file.';
                }
            },
            change_file_input: function(event) {
                let file = event.target.files[0];
                let current_object = this;
                current_object.read_file(file);
                // event.target.val('');
            },
            set_background: function(canvas_type) {
                // Create static layer for canvas
                let current_object = this;
                let dot_radius = current_object.dot_radius;
                let select_area = current_object.select_area;
                let source_canvas_draw_region = current_object.draw_region.source_canvas;
                let target_canvas_draw_region = current_object.draw_region.target_canvas;
                let source_canvas = current_object.jquery_element.source_canvas;
                let target_canvas = current_object.jquery_element.target_canvas;
                let source_image = current_object.dom_element.source_image;

                if (canvas_type === 'target_canvas') {
                    // target_canvas size/ratio changes by source_canvas selected area
                    let target_canvas_ratio = select_area['size'][0]*source_canvas.width()/(current_object.select_area['size'][1]*source_canvas.height());
                    if (target_canvas_ratio > 1)
                    {
                        target_canvas.css({
                            'width':'',
                            'height':100/target_canvas_ratio+'%',
                            'top':(50-50/target_canvas_ratio)+'%',
                            'left':'0'
                        });
                    }
                    else
                    {
                        target_canvas.css({
                            'width':100*target_canvas_ratio+'%',
                            'height':'',
                            'left':(50-50*target_canvas_ratio)+'%',
                            'top':'0'
                        });
                    }
                    target_canvas.attr({
                        'width':target_canvas.width(),
                        'height':target_canvas.height()
                    });
                }

                // Clear Canvas
                current_object.canvas_context[canvas_type].clearRect(0,0,current_object.jquery_element[canvas_type].width(),current_object.jquery_element[canvas_type].height());
                // Fill White Background for Transparent Images
                if (current_object.target_image_format === 'image/png') {
                    current_object.canvas_context[canvas_type].clearRect(0,0,current_object.jquery_element[canvas_type].width(),current_object.jquery_element[canvas_type].height());
                    current_object.canvas_context[canvas_type].drawImage(current_object.canvas_transparent_image,0,0,current_object.jquery_element[canvas_type].width(),current_object.jquery_element[canvas_type].height());
                } else {
                    current_object.canvas_context[canvas_type].fillStyle = "#ffffff";
                    current_object.canvas_context[canvas_type].fillRect(0, 0, current_object.jquery_element[canvas_type].width(),current_object.jquery_element[canvas_type].height());
                }

                // Check the image is loaded properly (height 0 would trigger js error)
                if(source_image.height)
                {
                    if (canvas_type === 'source_canvas') {
                        // Set background image and clipping region
                        let source_image_ratio = source_image.width / source_image.height;
                        let target_image_ratio = source_image_ratio;
                        let source_image_size = [0,0];

                        if (target_image_ratio < current_object.select_area_ratio[0])
                        {
                            target_image_ratio = current_object.select_area_ratio[0];
                        }
                        if (target_image_ratio > current_object.select_area_ratio[1])
                        {
                            target_image_ratio = current_object.select_area_ratio[1];
                        }
                        // TODO: adjust source_canvas draw region
                        if (source_image_ratio <= source_canvas.width()/source_canvas.height())
                        {
                            source_image_size[1] = source_canvas.height() * (1-current_object.source_canvas_margin*2);
                            source_image_size[0] = source_image_size[1] / source_image.height * source_image.width;
                            // current_object.canvas_context[canvas_type].drawImage(source_image,(source_canvas.width() - source_image_size[0])/2,source_canvas.height() * current_object.source_canvas_margin,source_image_size[0],source_image_size[1]);
                            // source_canvas_draw_region = Object.assign(source_canvas_draw_region,[(source_canvas.width() - source_image_size[0])/2,source_canvas.height() * current_object.source_canvas_margin,source_image_size[0],source_image_size[1]]);
                            //ctx.clip();

                        }
                        else
                        {
                            source_image_size[0] = source_canvas.width() * (1-current_object.source_canvas_margin*2);
                            source_image_size[1] = source_image_size[0] / source_image.width * source_image.height;
                            // current_object.canvas_context[canvas_type].drawImage(source_image,source_canvas.width() * current_object.source_canvas_margin,(source_canvas.height() - source_image_size[1])/2,source_image_size[0],source_image_size[1]);

                            // source_canvas_draw_region = Object.assign(source_canvas_draw_region,[source_canvas.width() * current_object.source_canvas_margin,(source_canvas.height() - source_image_size[1])/2,source_image_size[0],source_image_size[1]]);
                            //ctx.clip();

                        }
                        current_object.canvas_context[canvas_type].drawImage(source_image,(source_canvas.width() - source_image_size[0])/2,(source_canvas.height() - source_image_size[1])/2,source_image_size[0],source_image_size[1]);
                        current_object.image_area['start'][0] = (1 - source_image_size[0]/source_canvas.width())/2;
                        current_object.image_area['start'][1] = (1 - source_image_size[1]/source_canvas.height())/2;
                        current_object.image_area['size'][0] = source_image_size[0]/source_canvas.width();
                        current_object.image_area['size'][1] = source_image_size[1]/source_canvas.height();


                        current_object.draw_region.source_canvas = Object.assign(current_object.draw_region.source_canvas, [dot_radius,dot_radius,source_canvas.width()-2*dot_radius,source_canvas.height()-2*dot_radius]);
                        select_area['size'][0] = source_image_size[0]/source_canvas.width();
                        select_area['size'][1] = source_image_size[1]/source_canvas.height();
                        if (source_image_ratio < target_image_ratio)
                        {
                            select_area['size'][1] = select_area['size'][0]/target_image_ratio;
                        }
                        else
                        {
                            select_area['size'][0] = select_area['size'][1]*target_image_ratio;
                        }
                        select_area['start'][0] = (1 - select_area['size'][0])/2;
                        select_area['start'][1] = (1 - select_area['size'][1])/2;

                        // current_object.image_area['start'][0] = select_area['start'][0];
                        // current_object.image_area['start'][1] = select_area['start'][1];
                        // current_object.image_area['size'][0] = select_area['size'][0];
                        // current_object.image_area['size'][1] = select_area['size'][1];

                    } else {

                        // Make draw region for target_canvas
                        target_canvas_draw_region[2] = target_canvas.width()*source_canvas_draw_region[2]/source_canvas.width()/select_area['size'][0];
                        target_canvas_draw_region[3] = target_canvas.height()*source_canvas_draw_region[3]/source_canvas.height()/select_area['size'][1];
                        target_canvas_draw_region[0] = (source_canvas_draw_region[0] - select_area['start'][0]*source_canvas.width())*target_canvas_draw_region[2]/source_canvas_draw_region[2];
                        target_canvas_draw_region[1] = (source_canvas_draw_region[1] - select_area['start'][1]*source_canvas.height())*target_canvas_draw_region[3]/source_canvas_draw_region[3];

                        current_object.canvas_context[canvas_type].drawImage(source_image,target_canvas_draw_region[0],target_canvas_draw_region[1],target_canvas_draw_region[2],target_canvas_draw_region[3]);


                    }
                    current_object.canvas_background[canvas_type] = current_object.canvas_context[canvas_type].getImageData(0,0,current_object.jquery_element[canvas_type].width(),current_object.jquery_element[canvas_type].height());

                }
            },
            draw_canvas: function (canvas_type) {
                let current_object = this;
                let canvas = current_object.jquery_element[canvas_type];
                let ctx = current_object.canvas_context[canvas_type];
                let select_area = current_object.select_area;
                let select_area_ratio = current_object.select_area_ratio;
                let dot_radius = current_object.dot_radius;

                // Wipe canvas
                ctx.clearRect(0, 0, canvas.width(), canvas.height());

                // Draw Background
                if (current_object.canvas_background[canvas_type]) {
                    ctx.putImageData(current_object.canvas_background[canvas_type], 0, 0);
                }
                //target_canvas_background = ctx.getImageData(select_area['start'][0]*canvas.width(),select_area['start'][1]*canvas.height(),select_area['size'][0]*canvas.width(),select_area['size'][1]*canvas.height());

                if (canvas_type === 'source_canvas') {
                    let canvas_draw_region = current_object.draw_region['source_canvas'];
                    // Draw Select Area Shadow
                    ctx.fillStyle = 'rgba(0,0,0,0.5)';
                    // shadow top part
                    // ctx.fillRect(select_area['start'][0]*canvas.width(),canvas_draw_region[1],select_area['size'][0]*canvas.width(),select_area['start'][1]*canvas.height()-canvas_draw_region[1]);
                    ctx.fillRect(select_area['start'][0]*canvas.width(),0,select_area['size'][0]*canvas.width(),select_area['start'][1]*canvas.height());

                    // shadow right part
                    // ctx.fillRect((select_area['start'][0]+select_area['size'][0])*canvas.width(),canvas_draw_region[1],canvas_draw_region[0]+canvas_draw_region[2]-(select_area['start'][0]+select_area['size'][0])*canvas.width(),canvas_draw_region[3]);
                    ctx.fillRect((select_area['start'][0]+select_area['size'][0])*canvas.width(),0,(1 - select_area['start'][0] - select_area['size'][0])*canvas.width(),canvas.height());
                    // shadow bottom part
                    // ctx.fillRect(select_area['start'][0]*canvas.width(),(select_area['start'][1]+select_area['size'][1])*canvas.height(),select_area['size'][0]*canvas.width(),canvas_draw_region[1]+canvas_draw_region[3]-(select_area['start'][1]+select_area['size'][1])*canvas.height());
                    ctx.fillRect(select_area['start'][0]*canvas.width(),(select_area['start'][1]+select_area['size'][1])*canvas.height(),select_area['size'][0]*canvas.width(),(1 - select_area['start'][1] - select_area['size'][1])*canvas.height());
                    // shadow left part
                    // ctx.fillRect(canvas_draw_region[0],canvas_draw_region[1],select_area['start'][0]*canvas.width()-canvas_draw_region[0],canvas_draw_region[3]);
                    ctx.fillRect(0,0,select_area['start'][0]*canvas.width(),canvas.height());

                    // Store Select Area Border
                    ctx.beginPath();
                    ctx.strokeStyle = '#2196f3';
                    ctx.fillStyle = '#2196f3';
                    ctx.lineWidth = 2;
                    ctx.rect(select_area['start'][0]*canvas.width(),select_area['start'][1]*canvas.height(),select_area['size'][0]*canvas.width(),select_area['size'][1]*canvas.height());
                    ctx.stroke();

                    // When ratio is fixed, there's no edge resize function
                    if (select_area_ratio[1] > select_area_ratio[0])
                    {
                        // Store Select Area Edge Operating Dots
                        // top edge
                        ctx.beginPath();
                        // ctx.arc((select_area['start'][0]+select_area['size'][0]/2)*canvas.width(),select_area['start'][1]*canvas.height(),dot_radius,0,2*Math.PI);
                        ctx.rect((select_area['start'][0]+select_area['size'][0]/2)*canvas.width()-dot_radius,select_area['start'][1]*canvas.height()-dot_radius,dot_radius*2,dot_radius*2);
                        ctx.closePath();
                        ctx.fill();

                        // right edge
                        ctx.beginPath();
                        // ctx.arc((select_area['start'][0]+select_area['size'][0])*canvas.width(),(select_area['start'][1]+select_area['size'][1]/2)*canvas.height(),dot_radius,0,2*Math.PI);
                        ctx.rect((select_area['start'][0]+select_area['size'][0])*canvas.width()-dot_radius,(select_area['start'][1]+select_area['size'][1]/2)*canvas.height()-dot_radius,dot_radius*2,dot_radius*2);
                        ctx.closePath();
                        ctx.fill();

                        // bottom edge
                        ctx.beginPath();
                        // ctx.arc((select_area['start'][0]+select_area['size'][0]/2)*canvas.width(),(select_area['start'][1]+select_area['size'][1])*canvas.height(),dot_radius,0,2*Math.PI);
                        ctx.rect((select_area['start'][0]+select_area['size'][0]/2)*canvas.width()-dot_radius,(select_area['start'][1]+select_area['size'][1])*canvas.height()-dot_radius,dot_radius*2,dot_radius*2);
                        ctx.closePath();
                        ctx.fill();

                        // left edge
                        ctx.beginPath();
                        // ctx.arc(select_area['start'][0]*canvas.width(),(select_area['start'][1]+select_area['size'][1]/2)*canvas.height(),dot_radius,0,2*Math.PI);
                        ctx.rect(select_area['start'][0]*canvas.width()-dot_radius,(select_area['start'][1]+select_area['size'][1]/2)*canvas.height()-dot_radius,dot_radius*2,dot_radius*2);
                        ctx.closePath();
                        ctx.fill();
                    }

                    // Store Select Area Corner Operating Dots
                    ctx.beginPath();
                    //ctx.arc(select_area['start'][0]*canvas.width(),select_area['start'][1]*canvas.height(),dot_radius,0,2*Math.PI);
                    ctx.rect(select_area['start'][0]*canvas.width()-dot_radius,select_area['start'][1]*canvas.height()-dot_radius,dot_radius*2,dot_radius*2);
                    ctx.closePath();
                    ctx.fill();

                    ctx.beginPath();
                    //ctx.arc((select_area['start'][0]+select_area['size'][0])*canvas.width(),select_area['start'][1]*canvas.height(),dot_radius,0,2*Math.PI);
                    ctx.rect((select_area['start'][0]+select_area['size'][0])*canvas.width()-dot_radius,select_area['start'][1]*canvas.height()-dot_radius,dot_radius*2,dot_radius*2);
                    ctx.closePath();
                    ctx.fill();

                    ctx.beginPath();
                    //ctx.arc((select_area['start'][0]+select_area['size'][0])*canvas.width(),(select_area['start'][1]+select_area['size'][1])*canvas.height(),dot_radius,0,2*Math.PI);
                    ctx.rect((select_area['start'][0]+select_area['size'][0])*canvas.width()-dot_radius,(select_area['start'][1]+select_area['size'][1])*canvas.height()-dot_radius,dot_radius*2,dot_radius*2);
                    ctx.closePath();
                    ctx.fill();

                    ctx.beginPath();
                    //ctx.arc(select_area['start'][0]*canvas.width(),(select_area['start'][1]+select_area['size'][1])*canvas.height(),dot_radius,0,2*Math.PI);
                    ctx.rect(select_area['start'][0]*canvas.width()-dot_radius,(select_area['start'][1]+select_area['size'][1])*canvas.height()-dot_radius,dot_radius*2,dot_radius*2);
                    ctx.closePath();
                    ctx.fill();
                }
            },
            change_cursor: function (event, action_id) {
                let source_canvas = this.jquery_element.source_canvas;
                switch(action_id)
                {
                    case 1:
                        source_canvas.css('cursor','move');
                        break;
                    case 2:
                        source_canvas.css('cursor','nw-resize');
                        break;
                    case 3:
                        source_canvas.css('cursor','n-resize');
                        break;
                    case 4:
                        source_canvas.css('cursor','sw-resize');
                        break;
                    case 5:
                        source_canvas.css('cursor','e-resize');
                        break;
                    case 6:
                        source_canvas.css('cursor','se-resize');
                        break;
                    case 7:
                        source_canvas.css('cursor','s-resize');
                        break;
                    case 8:
                        source_canvas.css('cursor','ne-resize');
                        break;
                    case 9:
                        source_canvas.css('cursor','e-resize');
                        break;
                    case 10:
                        source_canvas.css('cursor','pointer');
                        break;
                    default:
                        source_canvas.css('cursor','default');

                }
            },
            save: function () {
                let current_object = this;
                let source_canvas_draw_region = current_object.draw_region.source_canvas;
                let source_canvas = current_object.jquery_element.source_canvas;
                let select_area = current_object.select_area;
                let source_image = current_object.dom_element.source_image;
                let target_image_quality = current_object.image_quality.target_image;

                let parent_field_name = current_object.field_name;
                if (!parent_field_name) {
                    parent_field_name = 'image_data';
                }



                // Create Image Object
                var target_image_array = [0,0,0,0];
                var temp_canvas = document.createElement('canvas');
                let target_ratio = current_object.target_image.ratio;
                if (target_ratio === 'auto') {
                    target_ratio = select_area['size'][0]*source_canvas.width() / (select_area['size'][1]*source_canvas.height());
                }
                if (current_object.target_image.width !== 'auto') {
                    temp_canvas.width = current_object.target_image.width;
                    if (current_object.target_image.height !== 'auto') {
                        temp_canvas.height = current_object.target_image.height;
                    } else {
                        temp_canvas.height = temp_canvas.width/target_ratio;
                    }
                } else {
                    if (current_object.target_image.height !== 'auto') {
                        temp_canvas.height = current_object.target_image.height;
                        temp_canvas.width = temp_canvas.height*target_ratio;
                    } else {
                        temp_canvas.width = source_canvas.width()*select_area['size'][0];
                        temp_canvas.height = source_canvas.height()*select_area['size'][1];
                    }
                }
                // temp_canvas.width = target_image_width;
                // temp_canvas.height = target_image_width/target_canvas_ratio;
                var temp_ctx = temp_canvas.getContext('2d');

                // target_image_array[2] = temp_canvas.width*source_canvas_draw_region[2]/source_canvas.width()/select_area['size'][0];
                // target_image_array[3] = temp_canvas.height*source_canvas_draw_region[3]/source_canvas.height()/select_area['size'][1];
                // target_image_array[0] = (source_canvas_draw_region[0] - select_area['start'][0]*source_canvas.width())*target_image_array[2]/source_canvas_draw_region[2];
                // target_image_array[1] = (source_canvas_draw_region[1] - select_area['start'][1]*source_canvas.height())*target_image_array[3]/source_canvas_draw_region[3];

                // target_image_array[2] = temp_canvas.width/select_area['size'][0]*current_object.image_area['size'][0];
                // target_image_array[3] = temp_canvas.height/select_area['size'][1]*current_object.image_area['size'][1];
                // target_image_array[0] = (current_object.image_area['start'][0] - select_area['start'][0])/current_object.image_area['size'][0]*target_image_array[2];
                // target_image_array[1] = (current_object.image_area['start'][1] - select_area['start'][1])/current_object.image_area['size'][1]*target_image_array[3];

                target_image_array[0] = (current_object.image_area['start'][0] - select_area['start'][0]) / select_area['size'][0] * temp_canvas.width;
                target_image_array[1] = (current_object.image_area['start'][1] - select_area['start'][1]) / select_area['size'][1] * temp_canvas.height;
                target_image_array[2] = current_object.image_area['size'][0] / select_area['size'][0] * temp_canvas.width;
                target_image_array[3] = current_object.image_area['size'][1] / select_area['size'][1] * temp_canvas.height;


                if (current_object.target_image_format !== 'image/png') {
                    temp_ctx.fillStyle = '#ffffff';
                    temp_ctx.fillRect(0,0,temp_canvas.width,temp_canvas.height);
                }
console.log('allen debug temp_ctx drawImage',source_image,target_image_array[0],target_image_array[1],target_image_array[2],target_image_array[3],source_canvas_draw_region,select_area,current_object);
console.log(temp_canvas.width,temp_canvas.height,temp_canvas.width/temp_canvas.height,select_area['size'],target_ratio);
console.log('current_object.image_area, select_area, temp_canvas.width,temp_canvas.height',JSON.stringify(current_object.image_area),JSON.stringify(select_area),temp_canvas.width,temp_canvas.height);
                temp_ctx.drawImage(source_image,target_image_array[0],target_image_array[1],target_image_array[2],target_image_array[3]);
                // target_image.src = temp_canvas.toDataURL('image/jpeg',target_image_quality);
                current_object.$emit('submit',temp_canvas.toDataURL(current_object.target_image_format,target_image_quality),parent_field_name);
            },
            cancel: function () {
                let current_object = this;
                let parent_field_name = current_object.field_name;
                if (!parent_field_name) {
                    parent_field_name = 'image_data';
                }

                // Erase error message if applicable
                current_object.message_option.message_type = '';
                current_object.message_option.message = '';

                if ($(current_object.$el.parentNode).hasClass('scrolltop_container')) {
                    let scrolltop_wrapper = $(current_object.$el.parentNode).closest('.scrolltop_wrapper');
                    if (scrolltop_wrapper.length > 0) {
                        $('html, body').scrollTop(scrolltop_wrapper.offset().top);
                    }
                }
                current_object.$emit('submit','',parent_field_name,'cancel');
            }
        },
    }
</script>